/**
 * Une heure de magasin en texte (03/11/2026) : les horaires vont a la
 * demi-heure pres — Bourgogne ouvre a 8h30, enregistre 8.5.
 *   libelleHeure(8.5) -> "8h30"   libelleHeure(21) -> "21h"
 *   heureHHMM(8.5)   -> "08:30"
 */
export function libelleHeure(h: number): string {
  const n = Number(h) || 0;
  const heures = Math.floor(n);
  const minutes = Math.round((n - heures) * 60);
  return minutes ? `${heures}h${String(minutes).padStart(2, "0")}` : `${heures}h`;
}

export function heureHHMM(h: number): string {
  const n = Number(h) || 0;
  const heures = Math.floor(n);
  const minutes = Math.round((n - heures) * 60);
  return `${String(heures).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
}

/** Les choix d'un menu d'horaires, de demi-heure en demi-heure. */
export function demiHeures(de: number, a: number): number[] {
  const l: number[] = [];
  for (let h = de; h <= a; h += 0.5) l.push(h);
  return l;
}
